module.exports = __webpack_public_path__ + "static/media/circleFrame6.5c2396f4.svg";